export default hint

/** @ngInject */
function hint(ImplementationToText, DeviceChecker, Hint, ErrorCatcher) {
    return ({
        restrict: 'E',
        template: require('./view.jade')(),
        scope: {
            hint: '=',
            state: '@',
            large: '=',
            hintClass: '=',
        },
        link(scope, element, attrs) {
            scope.max = 5
            scope.rate = scope.hint.rating ? scope.hint.rating : 0

            scope.implementationToText = (implementation) => ImplementationToText[implementation]
            scope.columnSize = (state) => {
                return { flow: 'col-sm-3', hints: 'col-sm-4' }[state] || 'col-sm-4'
            }
            scope.isMobile = () => DeviceChecker.isMobile()
            scope.saveRating = (rating) => Hint.saveComment({ id_hint: scope.hint._id, rating }).$promise.catch(ErrorCatcher.catchError)
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/hint/directive.js